module.exports = "/images/vendor/flag-icon-css/flags/4x3/mo.svg?b6d4d1f6c34ca7e148035b1aea886080";